import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from 'react'
import { cn } from '@/lib/cn'
import styles from './IconButton.module.scss'

export type IconButtonVariant = 'outline' | 'ghost'
export type IconButtonSize = 'sm' | 'md'

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** Required for accessibility (icon-only button). */
  'aria-label': string
  variant?: IconButtonVariant
  size?: IconButtonSize
  children: ReactNode
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  { variant = 'outline', size = 'md', className, children, type, ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type ?? 'button'}
      className={cn(styles.iconButton, styles[`variant-${variant}`], styles[`size-${size}`], className)}
      {...rest}
    >
      {children}
    </button>
  )
})
